/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Provider_Org_Setup_RequiredInputs */



/**
* | output |
* | --- |
* | "An administrator has to set up {name} under Settings → Integrations before anyone can connect it." |
*
* @param {Spaces_Provider_Org_Setup_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_provider_org_setup_required = /** @type {((inputs: Spaces_Provider_Org_Setup_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Provider_Org_Setup_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein Admin muss ${i?.name} unter Einstellungen → Integrationen einrichten, bevor jemand es verbinden kann.`)
	return /** @type {LocalizedString} */ (`An administrator has to set up ${i?.name} under Settings → Integrations before anyone can connect it.`)
});